import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconSleekSilhouetteGeneric = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="8.6"
      y="13.6"
      width="7.8"
      height="19.8"
      rx="1.4"
      stroke={color}
      strokeWidth="1.2"
    />
    <rect
      x="8.6"
      y="27.6"
      width="30.8"
      height="6.8"
      rx="1.4"
      fill="white"
      stroke={color}
      strokeWidth="1.2"
    />
  </svg>;
};

IconSleekSilhouetteGeneric.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconSleekSilhouetteGeneric;
